import { createContext, ReactNode, useContext, useRef } from 'react';

import { State, User, UserIds } from '../../../types/feed';

type Props = {
  state?: State;
  app: {
    appKey?: string;
    appId?: string;
    appSecret?: string;
  };
  initializeClientForUser: any;
  setError: (message: string) => void;
  allowToPost: () => void;
  disallowToPost: () => void;
  onSendMessageRef: any;
};

type ProviderProps = {
  children: ReactNode | undefined;
  state: State;
  value: {
    app: {
      appKey?: string;
      appId?: string;
      appSecret?: string;
    };
    initializeClientForUser: any;
    setError: (message: string) => void;
    allowToPost: () => void;
    disallowToPost: () => void;
    onSendMessageRef: any;
  };
};

export const FeedsContext = createContext<Props>({
  state: undefined,
  app: {
    appKey: undefined,
    appId: undefined,
    appSecret: undefined,
  },
  setError: () => null,
  allowToPost: () => null,
  disallowToPost: () => null,
  initializeClientForUser: () => null,
  onSendMessageRef: undefined,
});

export const FeedsContextProvider = ({
  children,
  state,
  value,
}: ProviderProps) => {
  return (
    <FeedsContext.Provider
      value={{
        state,
        ...value,
      }}
    >
      {children}
    </FeedsContext.Provider>
  );
};

export const useFeedsContext = () => useContext(FeedsContext);
